"use client";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  COLOR_ADDITIONAL_CORNELL_RED,
  COLOR_GREYSCALE_NTA_BLACK_40,
} from "~/theme/colors";
import { FontWeights } from "~/theme/typography";

import { PRICE_PANEL_CLASSES } from "./constants";

export const PricePanelContainer = styled(Box)(() => {
  return {
    display: "grid",
    gap: 12,
    gridAutoFlow: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textTransform: "capitalize",
    [`& .${PRICE_PANEL_CLASSES.currentPrice}`]: {
      fontSize: 16,
      fontFamily: "Primark Basis, Arial",
      fontWeight: FontWeights.fontWeightMedium,
    },
    [`& .${PRICE_PANEL_CLASSES.clearancePrice}`]: {
      color: COLOR_ADDITIONAL_CORNELL_RED,
    },
    [`& .${PRICE_PANEL_CLASSES.previousPrice}`]: {
      fontSize: 14,
      fontFamily: "Primark Basis, Arial",
      fontWeight: FontWeights.fontWeightRegular,
      color: COLOR_GREYSCALE_NTA_BLACK_40,
      textDecoration: "line-through",
    },
  };
});
